import { render, staticRenderFns } from "./GridPagerCpt.vue?vue&type=template&id=0e701d02&scoped=true&"
import script from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
export * from "./GridPagerCpt.vue?vue&type=script&lang=ts&"
import style0 from "./GridPagerCpt.vue?vue&type=style&index=0&id=0e701d02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e701d02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VPagination})
